export enum EntityNodeType {
  Consumer = 'Consumer',
  Third_Party = 'Third_Party'
}

export enum TransactionNodeType {
  Contract = 'Contract',
  Application = 'Application',
  Market = 'Market',
  Quote = 'Quote',
  Bind = 'Bind',
  Issue = 'Issue',
  Endorsement = 'Endorsement',
  ScheduleCancel = 'ScheduleCancel',
  Cancel = 'Cancel',
  Reinstate = 'Reinstate',
  SelfAudit = 'SelfAudit',
  Audit = 'Audit',
  ExtendTerm = 'ExtendTerm',
  Renewal = 'Renewal',
  Reissue = 'Reissue',
  Rewrite = 'Rewrite',
  ContractDisable = 'ContractDisable',
  ChangeConsumer = 'ChangeConsumer',
  NonRenew = 'NonRenew',
  ContractRate = 'ContractRate'
}

export enum ProcObjectCodeType {
  Application = 'Applicatn',
  Market = 'Market',
  Quote = 'Quote',
  Bind = 'Bind',
  Issue = 'Issue',
  Endorsement = 'Endorse',
  ScheduleCancel = 'CancSched',
  Cancel = 'Cancel',
  Reinstate = 'Reinstate',
  SelfAudit = 'SelfAudit',
  Audit = 'Audit',
  ExtendTerm = 'ExtendTerm',
  Renewal = 'Renew',
  Reissue = 'Reissue',
  Rewrite = 'Rewrite',
  ContractDisable = 'DisableCon',
  ChangeConsumer = 'ConsumChg',
  NonRenew = 'NonRenew',
  ContractRate = 'Rate'
}

export enum ArticleNodeType {
  CDAA_Vehicle = 'CDAA_Vehicle',
  CDAA_Driver = 'CDAA_Driver',
  CDAC_Underwriting = 'CDAC_Underwriting',
  CDAC_Filing = 'CDAC_Filing',
  CDAC_Auto_Symbol = 'CDAC_Auto_Symbol',
  CDAC_State_Rating = 'CDAC_State_Rating',
  CDAC_Truck_Equipment = 'CDAC_Truck_Equipment',
  CDAC_Truck_Interchange = 'CDAC_Truck_Interchange',
  CDAC_Truck_Zone = 'CDAC_Truck_Zone',
  CDAP_All_Risk = 'CDAP_All_Risk',
  CDAP_Underwriting = 'CDAP_Underwriting',
  Line_Wide = 'Line_Wide',
  CDGL_Class_Rating = 'CDGL_Class_Rating',
  CDGL_State_Rating = 'CDGL_State_Rating',
  CDGL_Claims_Made = 'CDGL_Claims_Made',
  CDGL_Underwriting = 'CDGL_Underwriting',
  CDMA_Misc_Article = 'CDMA_Misc_Article',
  CDMA_ERP = 'CDMA_ERP',
  CDPL_Rating = 'CDPL_Rating',
  CDPL_Individuals = 'CDPL_Individuals',
  CDPL_Underwriting = 'CDPL_Underwriting',
  CDMM_Facility = 'CDMM_Facility',
  CDMM_Underwriting = 'CDMM_Underwriting',
  CDMM_Individual = 'CDMM_Individual',
  CDAM_Animal = 'CDAM_Animal',
  CDDO_Rating = 'CDDO_Rating',
  CDEP_Rating = 'CDEP_Rating',
  CDCR_Rating = 'CDCR_Rating',
  CDEO_Job = 'CDEO_Job',
  CDEO_Rating = 'CDEO_Rating',
  CDEO_Underwriting = 'CDEO_Underwriting',
  CDHM_CPL = 'CDHM_CPL',
  CDHM_Homeowners = 'CDHM_Homeowners',
  CDHM_Mobile_Home = 'CDHM_Mobile_Home',
  CDIM_Accounts_Receivable = 'CDIM_Accounts_Receivable',
  CDIM_Builders_Risk = 'CDIM_Builders_Risk',
  CDIM_Builders_Risk_Underwriting = 'CDIM_Builders_Risk_Underwriting',
  CDIM_Communications = 'CDIM_Communications',
  CDIM_EDP = 'CDIM_EDP',
  CDIM_EDP_Underwriting = 'CDIM_EDP_Underwriting',
  CDIM_Equipment_Floater = 'CDIM_Equipment_Floater',
  CDIM_Schedule_Summary = 'CDIM_Schedule_Summary',
  CDIM_Subcontractor_Underwriting = 'CDIM_Subcontractor_Underwriting',
  CDIM_Transportation = 'CDIM_Transportation',
  CDIM_Transportation_Rigging = 'CDIM_Transportation_Rigging',
  CDGK_Rating = 'CDGK_Rating',
  CDGD_PhysDam_Loc = 'CDGD_PhysDam_Loc',
  CDGK_Underwriting = 'CDGK_Underwriting',
  CDJB_Individuals = 'CDJB_Individuals',
  CDJB_Rating = 'CDJB_Rating',
  CDJB_Underwriting = 'CDJB_Underwriting',
  CDGD_Rating = 'CDGD_Rating',
  CDGD_Underwriting = 'CDGD_Underwriting',
  CDUX_Care_Custody_Control = 'CDUX_Care_Custody_Control',
  CDUX_Location = 'CDUX_Location',
  CDUX_Underlying = 'CDUX_Underlying',
  CDPC_Blanket_Rating = 'CDPC_Blanket_Rating',
  CDPC_Class_Rating = 'CDPC_Class_Rating',
  CDPC_Glass_Schedule = 'CDPC_Glass_Schedule',
  CDPC_Glass_Underwriting = 'CDPC_Glass_Underwriting',
  CDPC_Underwriting = 'CDPC_Underwriting',
  CDPC_Underwriting_Location = 'CDPC_Underwriting_Location',
  CDPO_Rating = 'CDPO_Rating',
  CDPX_Rating = 'CDPX_Rating',
  CDSB_Rating = 'CDSB_Rating',
  CDLL_Rating = 'CDLL_Rating',
  CDLL_Underwriting = 'CDLL_Underwriting',
  CDPP_Schedule = 'CDPP_Schedule',
  CDWC_Class_Rating = 'CDWC_Class_Rating',
  CDWC_Individual = 'CDWC_Individual',
  CDWC_Other_State = 'CDWC_Other_State',
  CDWC_State_Rating = 'CDWC_State_Rating',
  CDWC_Underwriting = 'CDWC_Underwriting'
}

export enum ArticleTypeByArticleNodeType {
  Line_Wide = 'LINE',
  CDMA_Misc_Article = 'MISCAR',
  CDMA_ERP = 'ERP',
  CDAA_Driver = 'AADRVR',
  CDAA_Vehicle = 'AAVEH',
  CDAC_Underwriting = 'ACUND',
  CDAC_Filing = 'ACFIL',
  CDAC_Auto_Symbol = 'ACSYMB',
  CDAC_State_Rating = 'ACSR',
  CDAC_Truck_Equipment = 'ACEQUP',
  CDAC_Truck_Interchange = 'ACTI',
  CDAC_Truck_Zone = 'ACTZ',
  CDAP_All_Risk = 'APALL',
  CDAP_Underwriting = 'APUND',
  CDGL_Class_Rating = 'GLCR',
  CDGL_State_Rating = 'GLSR',
  CDGL_Claims_Made = 'GLCM',
  CDGL_Underwriting = 'GLUND',
  CDPL_Rating = 'PRLR',
  CDPL_Individuals = 'PLIND',
  CDPL_Underwriting = 'PRUND',
  CDMM_Facility = 'MMFAC',
  CDMM_Underwriting = 'MMUND',
  CDMM_Individual = 'MMIND',
  CDAM_Animal = 'AMAN',
  CDDO_Rating = 'DOR',
  CDEP_Rating = 'EPR',
  CDCR_Rating = 'CRIM',
  CDEO_Job = 'EOJ',
  CDEO_Rating = 'EOR',
  CDEO_Underwriting = 'EOUND',
  CDHM_CPL = 'CPL',
  CDHM_Homeowners = 'HOME',
  CDHM_Mobile_Home = 'Mobile',
  CDIM_Accounts_Receivable = 'IMAR',
  CDIM_Builders_Risk = 'IMBR',
  CDIM_Builders_Risk_Underwriting = 'IMBRU',
  CDIM_Communications = 'IMCOM',
  CDIM_EDP = 'IMEDP',
  CDIM_EDP_Underwriting = 'IMEDPU',
  CDIM_Equipment_Floater = 'IMEQ',
  CDIM_Schedule_Summary = 'IMSCH',
  CDIM_Subcontractor_Underwriting = 'IMSUB',
  CDIM_Transportation = 'IMTR',
  CDIM_Transportation_Rigging = 'IMTRRG',
  CDGK_Rating = 'GKRat',
  CDGK_Underwriting = 'GKUnd',
  CDGD_PhysDam_Loc = 'GDPhys',
  CDGD_Rating = 'GDRate',
  CDGD_Underwriting = 'GARUND',
  CDJB_Individuals = 'JBIND',
  CDJB_Rating = 'JBR',
  CDJB_Underwriting = 'JBU',
  CDUX_Care_Custody_Control = 'CCC',
  CDUX_Location = 'UXLOC',
  CDUX_Underlying = 'UmbEx',
  CDPC_Blanket_Rating = 'PROPBL',
  CDPC_Class_Rating = 'PROPCR',
  CDPC_Glass_Schedule = 'PROPGS',
  CDPC_Glass_Underwriting = 'PROPGU',
  CDPC_Underwriting = 'PCUND',
  CDPC_Underwriting_Location = 'PCLOC',
  CDPO_Rating = 'POR',
  CDPX_Rating = 'PXR',
  CDSB_Rating = 'SBR',
  CDLL_Rating = 'LQRT',
  CDLL_Underwriting = 'LQUN',
  CDPP_Schedule = 'PPSCH',
  CDWC_Class_Rating = 'WCCR',
  CDWC_Individual = 'WCIND',
  CDWC_Other_State = 'WCOS',
  CDWC_State_Rating = 'WCSR',
  CDWC_Underwriting = 'WCUND'
}

export const ProfileArticles = [
  ArticleNodeType.CDAA_Driver,
  ArticleNodeType.CDJB_Individuals,
  ArticleNodeType.CDMM_Individual,
  ArticleNodeType.CDPL_Individuals,
  ArticleNodeType.CDWC_Individual
];

export enum SubArticleNodeType {
  CDAA_Driver_Vehicle = 'CDAA_Driver_Vehicle',
  CDAA_Driver_Violation = 'CDAA_Driver_Violation',
  CDGL_Class_Product = 'CDGL_Class_Product',
  CDMM_Individual_Schedule = 'CDMM_Individual_Schedule',
  CDAA_Driver_Discount = 'CDAA_Driver_Discount',
  CDAA_Driver_FinResp = 'CDAA_Driver_FinResp',
  CDAC_Filing_Detail = 'CDAC_Filing_Detail',
  CDPC_Underwriting_Protect = 'CDPC_Underwriting_Protect',
  CDAC_Truck_Terminal = 'CDAC_Truck_Terminal',
  CDUX_Primary = 'CDUX_Primary',
  CDUX_Vehicle = 'CDUX_Vehicle',
  CDUX_Watercraft = 'CDUX_Watercraft',
  CDIM_Communications_TowerAntenna = 'CDIM_Communications_TowerAntenna',
  CDIM_Schedule_Items = 'CDIM_Schedule_Items',
  CDIM_Transportation_Detail = 'CDIM_Transportation_Detail',
  CDIM_Builders_Risk_Rigging_Item = 'CDIM_Builders_Risk_Rigging_Item',
  CDCR_Employees = 'CDCR_Employees',
  CDCR_Money_Securities = 'CDCR_Money_Securities',
  CDCR_Safe_Vault_Info = 'CDCR_Safe_Vault_Info',
  CDJB_Rating_Exhibition = 'CDJB_Rating_Exhibition',
  CDJB_Rating_Off_Premises = 'CDJB_Rating_Off_Premises',
  CDJB_Underwriting_Protect = 'CDJB_Underwriting_Protect',
  CDPP_Item = 'CDPP_Item'
}

export const ArticleToSubArticleMap = {
  CDAA_Driver: ['CDAA_Driver_FinResp', 'CDAA_Driver_Discount', 'CDAA_Driver_Violation', 'CDAA_Driver_Vehicle'],
  CDAC_Filing: ['CDAC_Filing_Detail'],
  CDAC_Truck_Zone: ['CDAC_Truck_Terminal'],
  CDGL_Class_Rating: ['CDGL_Class_Product'],
  CDMM_Facility: ['CDMM_Individual_Schedule'],
  CDCR_Rating: ['CDCR_Employees', 'CDCR_Money_Securities', 'CDCR_Safe_Vault_Info'],
  CDIM_Communications: ['CDIM_Communications_TowerAntenna'],
  CDIM_Schedule_Summary: ['CDIM_Schedule_Items'],
  CDIM_Transportation: ['CDIM_Transportation_Detail'],
  CDIM_Transportation_Rigging: ['CDIM_Builders_Risk_Rigging_Item'],
  CDJB_Rating: ['CDJB_Rating_Exhibition', 'CDJB_Rating_Off_Premises'],
  CDJB_Underwriting: ['CDJB_Underwriting_Protect'],
  CDUX_Underlying: ['CDUX_Primary', 'CDUX_Vehicle', 'CDUX_Watercraft'],
  CDPC_Underwriting: ['CDPC_Underwriting_Protect'],
  CDPP_Schedule: ['CDPP_Item'],
  CDIM_Builders_Risk: ['CDIM_Builders_Risk_Rigging_Item']
};

export enum PartyNodeType {
  Contract_Broker = 'Contract_Broker',
  Contract_Supplier = 'Contract_Supplier',
  Contract_Producer = 'Contract_Producer',
  Contract_FinanceCo = 'Contract_FinanceCo'
}

export enum EventType {
  Update = 'Update',
  Accept = 'Accept',
  Submit = 'Submit',
  Reject = 'Reject',
  Delete = 'Delete',
  Rate = 'Rate',
  Create = 'Create'
}

//List of all events that can be referenced in validation rules for this object
export const ContractObjectValidationEvents: EventType[] = [
  EventType.Create,
  EventType.Submit,
  EventType.Accept,
  EventType.Reject,
  EventType.Delete
];

export interface CostData {
  effDate?: Date;
  expDate?: Date;
  revDate?: Date;
  prevFullTerm?;
  prevWritten?;
  currNetChange?;
  newFullTerm?;
  newWritten?;
  newNetChange?;
  audit?: boolean;
  cancel?: boolean;
  netChangeMethod?;
  standardValue?;
}

export enum ContractProcTemplateActionTypes {
  Cancel = 'cancel',
  Proceed = 'proceed'
}

export interface ContractProcTemplateResultTypes {
  action: ContractProcTemplateActionTypes;
  count?: number;
  data?: any;
}

export enum FormDocPackageTypes {
  Contract = 'Contract',
  Quote = 'Quote',
  Bind = 'Bind'
}

export enum CostType {
  All = 'A',
  Premium = 'P',
  Fee = 'F',
  Tax = 'T'
}

export enum CommRateType {
  New_Comm_Rate = 'New_Comm_Rate',
  Renewal_Comm_Rate = 'Renewal_Comm_Rate',
  Rewrite_Comm_Rate = 'Rewrite_Comm_Rate',
  Endorse_Comm_Rate = 'Endorse_Comm_Rate',
  Renewal_Endorse_Comm_Rate = 'Renewal_Endorse_Comm_Rate'
}
